// transition control

/* frame: function(){
    if(wgl.transition == undefined) return;
    var a = wgl.trans.alpha;
    if(wgl.trans.on){
        if(a != 1) a += (1 - a) * wgl.trans.fadeIn;
    }else{
        if(a != 0) {
            a += -a * wgl.trans.fadeOut;
        }
    }
    wgl.trans.alpha = a;
    var tm = wgl.time.delta / 1000 * wgl.trans.speed * wgl.trans.alpha;
    wgl.transMat.uniforms.uTime.value += tm;
    wgl.transMat.uniforms.uAlpha.value = a;
},
time: 0,
speed: 0,
alpha: 0 */


page.three.control.transition.fadeTo = function(c, t){
    if(typeof(c) != "number") return;
    if(typeof(t) != "number") t = 1000;
    log.webgl(`PARTICLES: FadeTo(${c}, ${t})`, 2);
    c = Math.clamp(c, 0, 1);
    var v = page.three.v.transition;

    v.aStart = page.three.transMat.uniforms.uAlpha.value;
    v.aTarget = c;
    v.aVal = 0;
    v.aStep = 1 / t;
}

page.three.control.transition.speedTo = function(c, t){
    if(typeof(c) != "number") return;
    if(typeof(t) != "number") t = 1;
    //c = Math.clamp(c, 0, 1);
    log.webgl(`PARTICLES: Speed ${c}`, 2);
    var v = page.three.v.transition;

    v.sStart = v.speed;
    v.sTarget = c;
    v.sVal = 0;
    v.sStep = 1 / t;
}

page.three.control.transition.scroll = function(c){
    if(typeof(c) != "number") return;
    var v = page.three.v.transition;
    v.rTarget += c;
}

page.three.control.transition.scrollEnable = function(b){
    if(typeof(b) != "boolean") b = false;
    log.webgl(`PARTICLES: Scroll ${b?"On":"Off"}`, 2);
    var v = page.three.v.transition;
    v.scrollEnabled = b;
}

page.three.f.transition.calc = function(){
    var t=page.v.time;
    var s=page.v.scroll;
    var v = page.three.v.transition;
    var a;

    if(v.aVal != 1){
        a = page.three.transMat.uniforms.uAlpha;
        v.aVal += v.aStep * t.delta;
        v.aVal = Math.clamp(v.aVal, 0, 1);
        if(v.aVal >= 1){
            a.value = v.aTarget;
        }else{
            a.value = THREE.Math.lerp(v.aStart, v.aTarget, Math.ease.outSin(v.aVal));
        }
        if(a.value <= 0.001){
            page.three.transition.visible = false;
        }else{
            page.three.transition.visible = true;
        }
    }

    if(page.three.transition.visible){
        if(!page.three.v.alwaysRender){
            page.three.v.alwaysRender = true;
        }
    }else{
        if(page.three.v.alwaysRender && !page.three.v.isMain && page.three.v.bgDone){
            page.three.v.alwaysRender = false;
        }
    }

    if(v.sVal != 1){
        v.sVal += v.sStep * t.delta;
        v.sVal = Math.clamp(v.sVal, 0, 1);
        if(v.sVal >= 1){
            v.speed = v.sTarget;
        }else{
            v.speed = THREE.Math.lerp(v.sStart, v.sTarget, Math.ease.outSin(v.sVal));
        }
    }

    if(s.delta != 0 && v.scrollEnabled){
        v.rTarget += s.delta/2000;
    }

    if(v.rSpeed != 0 && v.scroll != v.rTarget){
        v.scroll = THREE.Math.lerp(v.scroll, v.rTarget, v.rSpeed);
        if(Math.abs(v.rTarget - v.scroll) <= 0.001){
            v.scroll = v.rTarget;
        }
        /* v.rVal += v.rStep * t.delta;
        v.rVal = Math.clamp(v.rVal, 0, 1);
        if(v.rVal >= 1){
            v.scroll = v.rTarget;
        }else{
            v.scroll = THREE.Math.lerp(v.rStart, v.rTarget, Math.ease.outSin(v.rVal));
        }
    }else{
        v.rVal = 1; */
    }

    page.three.transMat.uniforms.uTime.value += t.delta * v.speed * 0.001;
    if(page.three.transMat.uniforms.uScroll.value != v.scroll){
        page.three.transMat.uniforms.uScroll.value = v.scroll;
    }
    
}